module.exports = ".ui-steps .ui-steps-item {\n\twidth: 50%;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/alarm/alarm.component.css
// module id = ./src/app/alarm/alarm.component.css
// module chunks = main